import { render } from "./krJsonTree.vue?vue&type=template&id=0b88b8eb&scoped=true"
import script from "./krJsonTree.vue?vue&type=script&lang=js"
export * from "./krJsonTree.vue?vue&type=script&lang=js"

import "./krJsonTree.vue?vue&type=style&index=0&id=0b88b8eb&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b88b8eb"]])

export default __exports__